module.exports = __webpack_public_path__ + "img/facebook-sign-in-button.4b8b1f71.png";